var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconWarning = function IconWarning(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.864 21.078a1.92 1.92 0 100 3.84 1.92 1.92 0 000-3.84zm1.92-9.237c0 .678-.352 2.43-1.38 7.106h-1.079a735.615 735.615 0 00-.62-2.976c-.512-2.439-.76-3.625-.76-4.13a1.92 1.92 0 113.84 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.76 11.233c2.58 4.324 5.821 10.084 7.247 13.207.554 1.211 1.038 2.271.46 2.922-.213.565-1.018 2.156-14.602 2.156-13.585 0-14.39-1.591-14.603-2.156-.578-.651-.094-1.711.459-2.922 1.427-3.123 4.668-8.883 7.248-13.207 5.327-8.926 6.146-9.344 6.896-9.217.74-.128 1.568.29 6.894 9.217zm-6.896-6.984C13.454 7.1 3.854 23.68 3.044 26.451c2.427 1.434 23.215 1.434 25.64 0C27.877 23.68 18.276 7.1 15.864 4.249z",
    clipRule: "evenodd"
  }));
};

IconWarning.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconWarning;
//# sourceMappingURL=IconWarning.js.map